export enum LanguagesEnum {
  EN = "en",
  AR = "ar",
}
